'use client'

import { useEffect } from 'react'
import AlertContainer from '@/components/atoms/Alert/AlertContainer'
import AlertDescription from '@/components/atoms/Alert/AlertDescription'
import AlertTitle from '@/components/atoms/Alert/AlertTitle'
import ErrorRefreshButton from '@/components/atoms/Alert/ErrorRefreshButton'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    console.error('🚨 SSR ERROR:', error)
  }, [error])

  return (
    <AlertContainer height="100vh">
      <ErrorRefreshButton />

      <AlertTitle>SSR Crash Detected</AlertTitle>

      <AlertDescription style={{ whiteSpace: 'pre-wrap', color: 'salmon' }}>
        {error.message}
      </AlertDescription>

      {error.stack && (
        <pre
          style={{
            background: '#333',
            color: '#f88',
            padding: '1rem',
            marginTop: '1rem',
            fontSize: '0.8rem',
            whiteSpace: 'pre-wrap',
          }}
        >
          {error.stack}
        </pre>
      )}

      <button
        type="button"
        onClick={() => reset()}
        style={{
          marginTop: '1.5rem',
          padding: '0.75rem 1.5rem',
          background: '#444',
          color: '#fff',
          borderRadius: '0.5rem',
          cursor: 'pointer',
        }}
      >
        Try Again
      </button>
    </AlertContainer>
  )
}
